var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M12.2873 0.325962C12.6824 0.721067 12.7183 1.33934 12.3951 1.77502L12.2873 1.89984L2.68767 11.5L12.2873 21.1002C12.6824 21.4953 12.7183 22.1135 12.3951 22.5492L12.2873 22.674C11.8922 23.0691 11.2739 23.1051 10.8383 22.7818L10.7134 22.674L0.326341 12.2869C-0.0687647 11.8918 -0.104684 11.2736 0.218584 10.8379L0.326341 10.7131L10.7134 0.325962C11.1481 -0.108654 11.8527 -0.108654 12.2873 0.325962Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.4832a1d792d1de4866072a4f2f753d44.svg";
export { ForwardRef as ReactComponent };